export const getCashRegisters = (state) => state.cashRegisters
export const getCashRegister = (state) => (id) => { 
  return state.cashRegisters.find((caisse) => caisse.id === id) 
}